/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type AssignedOrganizationsViewQueryVariables = Types.Exact<{
  email: Types.Scalars['String']['input']
}>

export type AssignedOrganizationsViewQuery = {
  __typename?: 'Query'
  fleets: Array<{
    __typename?: 'BackofficeUserManagementFleet'
    id: string
    name: string
    operatorTenant: string
  }> | null
  organizations: Array<{
    __typename?: 'BackofficeOrganization'
    id: string
    name: string
    operatorTenants: Array<string>
    customerTenants: Array<string>
    ridepoolingServiceTenants: Array<string>
  }>
  serviceAreas: Array<{
    __typename?: 'ServiceArea'
    uuid: string
    id: string
    displayNames: Partial<Record<'de' | 'en' | 'no', string>>
    operatorTenants: Array<string>
  }>
}

export const AssignedOrganizationsViewDocument = gql`
    query AssignedOrganizationsView($email: String!) {
  fleets: backofficeUserFleetsByEmail(email: $email) {
    id
    name
    operatorTenant
  }
  organizations: backofficeOrganizations {
    id
    name
    operatorTenants
    customerTenants
    ridepoolingServiceTenants
  }
  serviceAreas {
    uuid
    id
    displayNames
    operatorTenants
  }
}
    `

/**
 * __useAssignedOrganizationsViewQuery__
 *
 * To run a query within a React component, call `useAssignedOrganizationsViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignedOrganizationsViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignedOrganizationsViewQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useAssignedOrganizationsViewQuery(
  baseOptions: Apollo.QueryHookOptions<
    AssignedOrganizationsViewQuery,
    AssignedOrganizationsViewQueryVariables
  > &
    (
      | { variables: AssignedOrganizationsViewQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    AssignedOrganizationsViewQuery,
    AssignedOrganizationsViewQueryVariables
  >(AssignedOrganizationsViewDocument, options)
}
export function useAssignedOrganizationsViewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AssignedOrganizationsViewQuery,
    AssignedOrganizationsViewQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AssignedOrganizationsViewQuery,
    AssignedOrganizationsViewQueryVariables
  >(AssignedOrganizationsViewDocument, options)
}
// @ts-ignore
export function useAssignedOrganizationsViewSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AssignedOrganizationsViewQuery,
    AssignedOrganizationsViewQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AssignedOrganizationsViewQuery,
  AssignedOrganizationsViewQueryVariables
>
export function useAssignedOrganizationsViewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AssignedOrganizationsViewQuery,
        AssignedOrganizationsViewQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AssignedOrganizationsViewQuery | undefined,
  AssignedOrganizationsViewQueryVariables
>
export function useAssignedOrganizationsViewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AssignedOrganizationsViewQuery,
        AssignedOrganizationsViewQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    AssignedOrganizationsViewQuery,
    AssignedOrganizationsViewQueryVariables
  >(AssignedOrganizationsViewDocument, options)
}
export type AssignedOrganizationsViewQueryHookResult = ReturnType<
  typeof useAssignedOrganizationsViewQuery
>
export type AssignedOrganizationsViewLazyQueryHookResult = ReturnType<
  typeof useAssignedOrganizationsViewLazyQuery
>
export type AssignedOrganizationsViewSuspenseQueryHookResult = ReturnType<
  typeof useAssignedOrganizationsViewSuspenseQuery
>
export type AssignedOrganizationsViewQueryResult = Apollo.QueryResult<
  AssignedOrganizationsViewQuery,
  AssignedOrganizationsViewQueryVariables
>
